<template>
    
</template>

<script>
    export default {
        name: "HomejsData",
        props: [
            'role',
            'user_id',

        ],
        methods:{

        },
    }
</script>

<style scoped>

</style>